import { combineReducers } from 'redux';
import appReducer from './appReducer';
import indexReducer from './indexReducer';

const createRootReducer = (router: any) => combineReducers({
  app: appReducer.reducer,
  index: indexReducer.reducer,
  router
});
export default createRootReducer;
